module.exports = __webpack_public_path__ + "img/m-banner-fgahubpa-ja-JP.6fc2bc26.png";